import useFetch from "../../../hooks/useFetch";

/**
 * Fetches the ordered set of first-class (type = 1) parent feedback questions.
 * @returns {{ apiData: {questions: Array}|null, loading: boolean, error: Error|null }}
 */
export const useFirstClassQuestions = () => {
  return useFetch("/parentFeedback/firstClassQuestions");
};
